import { render, staticRenderFns } from "./EditAsset.vue?vue&type=template&id=3c4e9edc&"
import script from "./EditAsset.vue?vue&type=script&lang=ts&"
export * from "./EditAsset.vue?vue&type=script&lang=ts&"
import style0 from "./EditAsset.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports